










































































































import {Component, Vue, Config, BasePage, Model, Watch, Prop} from '@/common';

@Component({})
export default class OrderEdit extends BasePage {
	@Model('change', {type: Boolean})
	private value!: boolean;

	@Watch('value')
	onValueChange(val) {
		this.showEdit = val;
	}

	@Watch('showEdit')
	onShowEditChange(val) {
		if (val === false) {
			this.resetForm('headForm');
			this.head.GUID = '';
		} else {
			if (this.propkey !== '') {
				this.dataLoading = true;
				this.$http
					.post('Basic/Custom/GetRecord', {
						GUID: this.propkey
					})
					.then(res => {
						this.dataLoading = false;
						if (res.data.status === 0) {
							Object.assign(this.head, res.data.head);
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			}
		}
		this.$emit('change', this.showEdit);
	}

	@Watch('propkey')
	ondataLoadingChange(val) {
	}

	head = {
		GUID: null,
		CUSTOMNO: null,
		CUSTOMNAME: null,
		CUSTOM: null,
		CUSTOMTEL: null,
		CUSTOMADRESS: null,
		SHORTNAME: null,
		PRECODE: null,
		INTERFACECODE: null
	};

	dataLoading = false;

	@Prop({})
	private custom!: Array<any>;

	@Prop({})
	private propkey!: String;

	showEdit = false;

	saveMask = false;

	columns = [];

	Save() {
		this.isFormValid('headForm', valid => {
			if (valid) {
				this.saveMask = true;
				this.$http
					.post('Basic/Custom/Save', {
						custom: this.head
					})
					.then(res => {
						if (res.data.status === 0) {
							this.saveMask = false;
							this.$message.success('保存成功');
							this.showEdit = false;
							this.$emit('on-ok');
						} else {
							this.saveMask = false;
							this.$message.warning(res.data.msg || '保存失败');
						}
					})
					.catch(err => {
						this.saveMask = false;
						this.$message.warning(err);
					});
			}
		});
	}

	mounted() {
		this.showEdit = this.value;
	}
}
